import { FC } from 'react'

import { CircleCheckmarkFullIcon, IconSizes } from '@inno-ui/icons'

import { AuthButton, AuthButtonColor, AuthButtonVariant } from '../AuthButton'
import styles from './AuthSuccess.module.scss'
import { AuthSuccessProps } from './AuthSuccess.types'

export const AuthSuccess: FC<AuthSuccessProps> = ({
  title,
  description,
  buttonLabel,
  onClick
}) => {
  return (
    <div className={styles.successContentWrapper}>
      <CircleCheckmarkFullIcon
        className={styles.icon}
        size={IconSizes.Size64}
        color='var(--white)'
      />
      <h3 className={styles.heading}>{title}</h3>
      <p className={styles.description}>{description}</p>
      {buttonLabel && (
        <AuthButton
          label={buttonLabel}
          variant={AuthButtonVariant.GHOST}
          colorType={AuthButtonColor.GHOST_DARKER}
          onClick={onClick}
          fullWidth
        />
      )}
    </div>
  )
}
